<script>
  import { createEventDispatcher } from "svelte";
  import { onMount } from "svelte";
  import { searchStr, searchRes } from "./stores/search.js";
  import { parseDuration } from "./utils.js";
  import { addVideo } from "./firebase.js";
  import { bgColor } from "./stores/background_color.js";

  const str = "";

  const dispatch = createEventDispatcher();

  let input;

  let throttle;

  function close() {
    dispatch("close");
  }

  function catchClick(e) {
    e.stopPropagation();
  }

  function catchEnter(e) {
    if (throttle) {
      clearTimeout(throttle);
    }
    if (e.code === "Enter") sendSearchReq();
  }

  function sendSearchReq() {
    gapi.client.youtube.search
      .list({
        part: "id",
        maxResults: 5,
        q: $searchStr,
      })
      .then((res) => {
        let ids = "";
        res.result.items.forEach((video) => {
          ids += video.id.videoId + ",";
        });
        ids = ids.slice(0, -1);

        gapi.client.youtube.videos
          .list({
            maxResults: 5,
            part: "contentDetails,snippet",
            id: ids,
          })
          .then((details) => {
            //format duration
            details.result.items.forEach((item) => {
              item.contentDetails.duration = parseDuration(
                item.contentDetails.duration,
              );
            });
            searchRes.set(details.result.items);
          });
      });
  }

  function search() {
    if (throttle) {
      clearTimeout(throttle);
    }
    throttle = setTimeout(() => {
      sendSearchReq();
    }, 750);
  }

  function add(video) {
    let vidObj = {
      videoId: video.id,
      title: video.snippet.title,
      duration: video.contentDetails.duration,
      thumbnail: video.snippet.thumbnails.default.url,
    };
    addVideo(vidObj);
    close();
  }

  onMount(() => {
    input.focus();
    input.select();
  });
</script>

<div class="bg" on:click={close} on:keydown={{}}>
  <div class="bar">
    <div class="search">
      <input
        placeholder="Search"
        bind:this={input}
        bind:value={$searchStr}
        on:click={catchClick}
        on:keydown={catchEnter}
        on:input={search}
      />
    </div>
    <i class="fa fa-times close" aria-hidden="true"></i>
  </div>
  <div class="items">
    {#each $searchRes as item, i}
      <!-- svelte-ignore a11y-click-events-have-key-events -->
      <div class="item" on:click={(e) => e.stopPropagation()}>
        <div
          class="thumb"
          alt={item.snippet.title}
          style="background-image: url({item.snippet.thumbnails.default.url})"
        />
        <div class="middle">
          <div class="title">
            <span>{item.snippet.title}</span>
          </div>
          <div class="details">{item.contentDetails.duration}</div>
        </div>
        <div class="right" on:click={add(item)} on:keydown={{}}>
          <i class="fas fa-plus" style="background: {$bgColor};" />
        </div>
      </div>
    {/each}
  </div>
</div>

<style>
  .bg {
    width: 100vw;
    height: 100vh;
    display: grid;
    grid-template-rows: 56px auto;
    position: fixed;
    background: #00000059;
    z-index: 9999;
    top: 0px;
  }

  .bar {
    width: 100%;
    height: 100%;
    background: #202020ff;
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    grid-column: 1 / 3;
    grid-row: 1 / 2;
    border-bottom: 2px solid #18181882;
    box-shadow: 0px 0px 5px #000000bf;
  }

  .search {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    max-width: 300px;
  }

  input {
    background: #141414;
    border: 1px solid #0a0a0a;
    border-radius: 2px;
    padding: 3px;
    margin: 0;
    margin-left: 30px;
    margin-right: 60px;
    color: #ffffffff;
    font-family: "Paytone One", Arial, Helvetica, sans-serif;
    padding-left: 15px;
    font-size: 18px;
    padding-bottom: 6px;
    max-width: 100%;
    width: 100%;
  }

  input::placeholder {
    color: rgb(255, 66, 19);
  }

  input:focus {
    outline: none;
  }

  .items {
    width: 100%;
    max-width: 540px;
    padding: 10px;
    box-sizing: border-box;
    grid-column: 1 / 3;
    grid-row: 2 / 2;
    margin-left: auto;
    margin-right: auto;
    overflow-x: hidden;
    overflow-y: auto;
  }

  .item:nth-child(1) {
    margin-top: 0;
  }

  .item {
    width: 100%;
    background: white;
    height: 76px;
    max-height: 76px;
    margin-top: 10px;
    border-radius: 14px 84px 84px 14px;
    overflow: hidden;
    display: grid;
    grid-template-columns: 100px auto 76px;
    /* font-family: "Oswald", sans-serif;
    font-family: "Noto Sans", sans-serif;
    font-family: "Poppins", sans-serif;
    font-family: "Varela Round", sans-serif; */
    font-family: "Paytone One", Arial, Helvetica, sans-serif;
  }

  .item > .thumb {
    height: 100%;
    min-width: 100%;
    background-position: center;
    grid-column: 1 / 2;
  }

  .item > .middle {
    grid-template-rows: 65% auto;
    height: 100%;
    max-height: 100%;
    width: 100%;
    display: grid;
  }

  .item > .right {
    display: flex;
    align-items: center;
    justify-content: center;
    grid-column: 3 / 4;
    width: 100%;
    height: 100%;
    cursor: pointer;
    transition: background 1.3s ease-in-out;
    filter: saturate(1.2) brightness(1.2);
  }

  .right > i {
    width: 60px;
    height: 60px;
    align-items: center;
    text-align: center;
    line-height: 60px;
    border-radius: 50px;
    color: white;
  }

  .title {
    font-family: "Paytone One", Arial, Helvetica, sans-serif;
    font-size: 16px;
    color: #4a4a4a;
    line-height: 19px;
    text-overflow: ellipsis;
    padding-left: 10px;
    padding-top: 8px;
    display: flex;
    align-items: center;
  }

  .title > span {
    -webkit-box-orient: vertical;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: normal;
  }

  .details {
    color: #878787;
    font-size: 14px;
    padding-left: 10px;
  }

  .close {
    position: absolute;
    right: 20px;
    color: white;
    cursor: pointer;
  }
</style>
